import React from 'react';
import { useTranslation } from 'react-i18next';
import useCoordinateMeeting from '../hookss/useCoordinateMeeting';
const ControllerParticipant = () => {
    const { t } = useTranslation();
    const { handleClick } = useCoordinateMeeting();
    return (React.createElement("div", null,
        React.createElement("div", { className: 'controller-meeting-header controler-header' }, t('menuController.controlParticipant')),
        React.createElement("div", { className: "controler-list-item " },
            React.createElement("div", { className: "controler-item item-tab shape-button", onClick: () => handleClick('turnOffAllMicro') }, t('menuController.turnOffAllMicro')),
            React.createElement("div", { className: "controler-item item-tab shape-button", onClick: () => handleClick('turnOffAllMedia') }, t('menuController.turnOffAllMedia')))));
};
export default ControllerParticipant;
